import React from "react";

export const SocialEvent = React.lazy(
  () => import("@/features/social-event/pages/SocialEventPage.tsx"),
);

export const SocialEventCreate = React.lazy(
  () => import("@/features/social-event/pages/SocialEventCreatePage.tsx"),
);

export const SocialEventCategory = React.lazy(
  () => import("@/features/social-event/pages/SocialEventCategoryPage.tsx"),
);

export const SocialEventDetail = React.lazy(
  () => import("@/features/social-event/pages/SocialEventDetailPage.tsx"),
);
